import tippy from 'tippy.js';

export default function() {
  tippy('.js-tippy', {
    content(reference) {
      const { content } = reference.dataset;

      if (content) {
        return content;
      }

      return '';
    },
    placement: 'bottom-start',
    allowHTML: true,
  });
}
